// src/pages/Login.js
import React from 'react';
import CVLogin from '../components/CVLogin';
import caravanImg from '../assets/caravan/Caravan.jpeg';

export default function Login() {
  const handleLogin = ({ username }) => {
    // TODO: integrate Firebase Auth login (do not log credentials)
    console.log('Login attempt for', username);
    // TODO: on success, navigate to /caravanbooking/home
  };

  return (
    <div
      className="relative min-h-screen bg-cover bg-center"
      style={{ backgroundImage: `url(${caravanImg})` }}
    >
      {/* conditional overlay: light mode white, dark mode black */}
      <div className="absolute inset-0 bg-white bg-opacity-10 dark:bg-black dark:bg-opacity-60" />
      {/* login pane */}
      <div className="relative z-10 flex items-center justify-center p-4 sm:p-20">
        <div className="backdrop-blur-lg bg-white bg-opacity-20 dark:bg-opacity-10 p-8 rounded-xl shadow-xl w-full max-w-md">
          <CVLogin onSubmit={handleLogin} />
        </div>
      </div>
    </div>
  );
}